module.exports = __webpack_public_path__ + "static/media/Asset 34.a4b2b447.png";